export default "__VITE_ASSET__DKEyliEw__"